module.exports = __webpack_public_path__ + "static/media/search.1f86600c.svg";